// extracted by mini-css-extract-plugin
export default {"Outer":"MiniSearch_Outer__6zS91"};